// Where each app lives in the stores.
//
// ⚠️ PLACEHOLDERS (founder 2026-10-02: "just put placeholder links in for now").
// Nothing is listed yet. Every one of these points at the store's search page so
// a click lands somewhere sane rather than on a 404, and `listed: false` is what
// the UI reads to say "coming to the App Store" instead of pretending otherwise.
//
// When an app is listed: put the real URL in, flip `listed` to true, and the
// badges, the welcome email and the /get page all start linking properly. They
// all read from here, so it is one edit in one file.

export const APPS = {
  work: {
    name: 'TempDash',
    blurb: 'Find shifts, clock in and get paid.',
    listed: false,
    ios:     'https://apps.apple.com/gb/search?term=tempdash',
    android: 'https://play.google.com/store/search?q=tempdash&c=apps',
  },
  cover: {
    name: 'TempDash Hub',
    blurb: 'Post shifts, approve hours and settle up.',
    listed: false,
    ios:     'https://apps.apple.com/gb/search?term=tempdash',
    android: 'https://play.google.com/store/search?q=tempdash&c=apps',
  },
}

export const appFor = (audience) => APPS[audience === 'cover' ? 'cover' : 'work']
